import { Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { PaginationParams } from "src/app/model/api/pagination-params";
import { AppState } from "src/app/store/app.reducer";
import { ItemsPagination } from "src/app/model/api/data-rest";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { selectAutomationAlias, selectConnectedAutomationsCommands, selectCurrentDevice, selectCurrentDeviceCommands, selectCurrentDeviceModel, selectRbeAccessLog, selectRbeAccessLogExport, selectRbeAccessLogPagination } from "src/app/store/device/device.selector";
import { AccessEvent, AccessExportLog, ActionEvent } from "src/app/model/access-log";
import { ACCESS_LOG_DEFAULT_SORT_COLUMN, ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION, ACCESS_LOG_PAGE_DEFAULT_SIZE, ACCESS_LOG_PAGE_SIZE_OPTIONS, ACCESS_LOG_TABLE_HEADER } from "src/app/conf/rbe-access-log";
import { DatePipe } from "@angular/common";
import { ConnectedAutomations, Device } from "src/app/model/device";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription, debounceTime, filter } from "rxjs";
import { pageSortChange } from "src/app/services/table";
import { Command, ConnectedAutomationsCommand } from "src/app/model/command";
import { StandardDesignParameters, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { exportToCsv } from "src/app/modules/shared/utils/exportData";
import moment from "moment";
import { selectDeviceTabIndex } from "src/app/store/home/home.selector";
import { DeviceModel } from "src/app/model/device-model";
import { EDeviceModel } from "src/app/conf/device-models";
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';
import { AutomationsAlias } from "src/app/model/automations-alias";

@Component({
	selector: 'app-rbe-log-access',
	templateUrl: './rbe-log-access.component.html',
	providers: [ConfirmationService, DialogService]
})

export class RbeLogAccessComponent implements OnInit, OnDestroy {
	@ViewChild(Table)
	table: Table;

	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;
	connectedAutomationsCommands$: Observable<ConnectedAutomationsCommand[] | undefined>;
	connectedAutomationsCommandsSub: Subscription | undefined;
	automationsAlias$: Observable<AutomationsAlias | undefined>;
	automationsAliasSub: Subscription | undefined;

	commands$: Observable<Command[] | undefined>;
	commandsSub: Subscription | undefined;
	logs: AccessEvent[];
	logs$: Observable<AccessEvent[] | undefined>;
	logsSub: Subscription | undefined;
	logsExport$: Observable<AccessEvent[] | undefined>;
	logsExportSub: Subscription | undefined;
	enableLogWarning = true;
	functionList: any[];

	logsLoading: boolean;
	automationsAlias: AutomationsAlias;

	deviceModel: DeviceModel = new DeviceModel();
	currDevice: Device;
	currDevice$: Observable<Device | undefined>;
	currDeviceSub: Subscription | undefined;

	searchFilter: FormControl = new FormControl('');

	acceptButtonStyle: string;
	rejectButtonStyle: string;
	rejectButtonVisible: boolean;

	filter: '';
	// filterForm: FormGroup;
	filterGroup: FormGroup;
	filterSub: Subscription;

	ref: DynamicDialogRef | undefined;

	MAX_EXPORT_LOG = 10000;

	TYPE_OUTPUT_ON = "10";
	TYPE_OUTPUT_OFF = "20";
	TYPE_OUTPUT_ON_TIME = "30";
	TYPE_OUTPUT_ON_MANTAINE = "40";
	TYPE_OUTPUT_ON_STEP = "50";
	TYPE_OUTPUT_OFF_MANTAINE = "60";
	TYPE_OUTPUT_OFF_STEP = "70";
	TYPE_OUTPUT_ON_FOR_SERVICE = "80";
	TYPE_OUTPUT_OFF_FOR_SERVICE = "90";
	TYPE_OUTPUT_JUST_ON = "100";
	TYPE_OUTPUT_JUST_OFF = "110";

	columns = ACCESS_LOG_TABLE_HEADER;
	paging$: Observable<ItemsPagination | undefined>;
	pagingSub: Subscription;
	pageSortSub: Subscription;
	paging: PaginationParams = {
		size: ACCESS_LOG_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: ACCESS_LOG_DEFAULT_SORT_COLUMN,
		order: ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	pageSize: number = ACCESS_LOG_PAGE_DEFAULT_SIZE;
	pageSizeOptions = ACCESS_LOG_PAGE_SIZE_OPTIONS;
	resultLength: number;

	dateTransform: DatePipe;

	minDate: Date = new Date("1900-01-01");
	today = new Date();
	maxDate = new Date();
	typeSub: Subscription;
	resultSub: Subscription;
	startDateSub: Subscription;
	endDateSub: Subscription;

	accessType: any[];
	accessResult: any[];
	commands: Command[];
	automationsCommands: ConnectedAutomationsCommand[];
	connectedAutomation: ConnectedAutomations[];

	saving = false;

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	COLUMN_TITLE_MIN_WD = 647;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private formBuilder: FormBuilder,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		this.enableLogWarning = false;
		this.store.dispatch(DeviceActions.getBoardUsersInfo({}));
		/*--
		NONE: 0,
		BOARD_USER_UNDEFINED: 200,
		KEY: 201,
		TIMER_EVENT: 202,
		INPUT_ON: 203,
		INPUT_OFF: 204,*/
		this.accessType = [
			{ value: 0, label: 'ALL_ACCESS_TYPES' },
			{ value: 1, label: 'RADIOCOMANDO_KLT' },
			{ value: 2, label: 'RADIOCOMANDO_STRAUSS_KLT' },
			{ value: 4, label: 'RADIOCOMANDO_KEYBOARD' },
			{ value: 5, label: 'RADIOCOMANDO_TRANSPONDER' },
			{ value: 17, label: 'RADIOCOMANDO_TOP' },
			{ value: 18, label: 'RADIOCOMANDO_TAM' },
			{ value: 64, label: 'RADIOCOMANDO_ROLLING' },
			{ value: 128, label: 'RADIOCOMANDO_TWIN_TTS_FIXED' },
			{ value: 200, label: 'BOARD_USER_UNDEFINED' },
			{ value: 201, label: 'KEY' },
			{ value: 202, label: 'TIMER_EVENT' },
			{ value: 203, label: 'INPUT_ON' },
			{ value: 204, label: 'INPUT_OFF' },
			{ value: 205, label: 'LOG_WEB_COMMAND' },
			{ value: 207, label: 'LOG_QUICK_EASY_CLOUD' }
		];

		this.generateBuFunctionList();
		/*NONE: 0,
		SUCCESS: 1,
		NOT_PRESENT: 2,
		NOT_ENABLED_ON_THIS_GATE: 3,
		NOT_ENABLED_ON_THIS_TIME: 4,*/
		this.accessResult = [
			{ value: 0, label: 'ALL_EVENTS_RESULT' },
			{ value: 1, label: 'LOG_USER_SUCCESS' },
			{ value: 2, label: 'LOG_USER_NOT_PRESENT' },
			{ value: 3, label: 'LOG_USER_NOT_ENABLED_ON_THIS_GATE' },
			{ value: 4, label: 'LOG_USER_NOT_ENABLED_ON_THIS_TIME' },
		];


		const endDate = new Date(this.today.getTime());
		const startDate = new Date(this.today.getTime());
		startDate.setDate(startDate.getDate() - 7);
		const curreLang = this.translate.currentLang;
		this.dateTransform = new DatePipe(curreLang);

		this.filterGroup = new FormGroup({
			'searchFilter': new FormControl(''),
			'type': new FormControl(this.accessType[0].value),
			'result': new FormControl(this.accessResult[0].value),
			'function': new FormControl(this.functionList !== undefined && this.functionList.length > 0 ? this.functionList[0] : null),
			'startDateTime': new FormControl(startDate, Validators.required),
			'endDateTime': new FormControl(endDate, Validators.required),
		});
		this.subscribeAll();
		this.onResize();

		this.filterSub = this.filterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			setTimeout(() => {
				this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'rbe_logaccess_change_filter', params: { page_title: 'RBEPLUS | LogAccess' } }));
			}, 2000);
			this.table?.reset();
			this.dispatchGetLogs();
		});
	}

	ngOnDestroy(): void {
		this.logsSub?.unsubscribe();
		this.filterSub?.unsubscribe();
		this.pagingSub?.unsubscribe();
		this.currDeviceSub?.unsubscribe();
		this.typeSub?.unsubscribe();
		this.resultSub?.unsubscribe();
		this.startDateSub?.unsubscribe();
		this.endDateSub?.unsubscribe();
		this.commandsSub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
		this.connectedAutomationsCommandsSub?.unsubscribe();
		this.automationsAliasSub?.unsubscribe();
	}

	initSelectors(): void {
		this.logs$ = this.store.select(selectRbeAccessLog);
		this.currDevice$ = this.store.select(selectCurrentDevice);
		this.paging$ = this.store.select(selectRbeAccessLogPagination);
		this.commands$ = this.store.select(selectCurrentDeviceCommands);
		this.logsExport$ = this.store.select(selectRbeAccessLogExport);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.connectedAutomationsCommands$ = this.store.select(selectConnectedAutomationsCommands);
		this.automationsAlias$ = this.store.select(selectAutomationAlias);
	}

	subscribeAll(): void {
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
			});

		this.commandsSub = this.commands$.subscribe(
			commands => {
				this.commands = commands;
				this.generateBuFunctionList();
			}
		);
		this.connectedAutomationsCommandsSub = this.connectedAutomationsCommands$.subscribe(
			automationsCommands => {
				this.automationsCommands = automationsCommands;
				this.generateBuFunctionList();
			}
		);

		this.logsSub = this.logs$.subscribe(
			(logs) => {
				if (logs !== undefined && logs.length <= 0) {
					this.enableLogWarning = true;
				} else {
					this.enableLogWarning = false;
				}
				this.logs = logs;
				this.logsLoading = false;
			}
		)

		this.currDeviceSub = this.currDevice$.subscribe(
			(device) => {
				this.currDevice = device
				if (device !== undefined) {
					this.connectedAutomation = device.ConnectedAutomations;
				} else {
					this.connectedAutomation = [];
				}
				this.dispatchGetLogs();
			}
		)

		this.pagingSub = this.paging$.subscribe((paging) => {
			if (paging !== undefined) {
				this.resultLength = paging.TotalCount;
				this.pageSize = paging.PageSize;
			}
		});

		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetLogs();
			}
		);
		this.automationsAliasSub = this.automationsAlias$.subscribe(automationsAlias => {
			this.automationsAlias = automationsAlias;
		});
	}

	get f(): any {
		return this.filterGroup.controls;
	}

	generateBuFunctionList(): void {

		/*getColor(comm: Command): string {
			if ((comm.Id >= 131 && comm.Id <= 136) || comm.Id === 1) {
				return 'warning';
			}
			return 'primary';
		}*/
		this.functionList = [];
		this.functionList.push({ Id: 0, Label: 'ALL' });
		if (this.commands !== undefined) {
			for (const command of this.commands) {
				if ((command.Id >= 131 && command.Id <= 136) || command.Id === 1) {
					continue;
				}
				let addStr = '';
				switch (command.Id) {
					case 256:
					case 257:
					case 258:
					case 259:
					case 10005:
						addStr = this.translate.instant('AUTOMATION') + ' A: ';
						break;
					case 260:
					case 261:
					case 262:
					case 263:
					case 10021:
						addStr = this.translate.instant('AUTOMATION') + ' B: ';
						break;
					case 264:
					case 265:
					case 266:
					case 267:
					case 10037:
						addStr = this.translate.instant('AUTOMATION') + ' C: ';
						break;
					case 268:
					case 269:
					case 270:
					case 271:
					case 10053:
						addStr = this.translate.instant('AUTOMATION') + ' D: ';
						break;
				}
				this.functionList.push({ Id: command.Id, Label: addStr + command.Description });
			}
		}
		if (this.automationsCommands !== undefined) {
			for (const autComm of this.automationsCommands) {
				for (const command of autComm.Commands) {
					let addStr = '';
					if (this.connectedAutomation !== undefined && this.connectedAutomation.length > 0 && this.connectedAutomation.find(aut => aut.CrpItemId === autComm.CrpItemId)) {
						addStr = this.connectedAutomation.find(aut => aut.CrpItemId === autComm.CrpItemId).Name;
					}
					this.functionList.push({ Id: command.Id, Label: addStr + ' - ' + command.Description, DeviceName: addStr });
				}
			}
		}
	}

	loadLogs(event: TableLazyLoadEvent) {

		this.paging = pageSortChange(this.paging, event);

		this.dispatchGetLogs();
	}

	translateData(str: string): string {
		let resStr = '';
		const fields = str.split('{{');
		for (const field of fields) {
			if (field.indexOf('}}') >= 0) {
				const toTranslate = field.split('}}');
				resStr = resStr + this.translate.instant('LOG_' + toTranslate[0]) + toTranslate[1];
			} else {
				resStr = resStr + field;
			}
		}
		return resStr;
	}

	userData(access: AccessEvent): string {
		switch (access.Type) {
			case 201:
				return this.translate.instant(this.keySelectorUser(access));
			case 202:
				return '';
			// return this.translate.instant('TIMER_EVENT');
			case 205:
				return '';
			case 206:
				if (access.Source === 'null null') {
					return this.translateData('{{PROGRAM_SCENARY}}');
				}
				return this.translateData(access.Source);
			default:
				return this.translateData(access.Source);
		}
	}

	keySelectorUser(access: AccessEvent): string {
		if (access.Passage.includes('SELECTOR_RIGHT_OFF')) {
			return 'KEY_RIGHT_OFF';
		}
		if (access.Passage.includes('SELECTOR_RIGHT_ON')) {
			return 'KEY_RIGHT_ON';
		}
		if (access.Passage.includes('SELECTOR_LEFT_OFF')) {
			return 'KEY_LEFT_OFF';
		}
		if (access.Passage.includes('SELECTOR_LEFT_ON')) {
			return 'KEY_LEFT_ON';
		}
		return '';
	}

	/*
	NONE: 0,
	RADIOSELECTOR: 17
	BOARD_USER_UNDEFINED: 200,
	KEY: 201,
	TIMER_EVENT: 202,
	INPUT_ON: 203,
	INPUT_OFF: 204,
	*/
	passageData(access: AccessEvent): string {
		if (access) {
			switch (access.Type) {
				case 17:
					return this.translate.instant("BOARD_USER");
				case 202:
					return this.translate.instant('TIMER_EVENT');
				case 203:
					return this.translateData(access.Passage);
				case 204:
					return this.translateData(access.Passage);
				case 205:
					return this.translate.instant('LOG_WEB_COMMAND');
				default:
					return this.translateData(access.Passage);
			}
		} else {
			return "";
		}
	}

	/*
	 NONE: 0,
	 SUCCESS: 1,
	 NOT_PRESENT: 2,
	 NOT_ENABLED_ON_THIS_GATE: 3,
	 NOT_ENABLED_ON_THIS_TIME: 4,
	*/
	getResult(result: number): string {
		switch (result) {
			case 0:
				return this.translate.instant('UNDEFINED');
			case 1:
				return this.translate.instant('SUCCESS');
			case 2:
				return this.translate.instant('LOG_USER_NOT_PRESENT');
			case 3:
				return this.translate.instant('LOG_NOT_ENABLED_ON_THIS_GATE');
			case 4:
				return this.translate.instant('LOG_NOT_ENABLED_ON_THIS_TIME');
			default:
				return this.translate.instant('UNDEFINED');
		}
	}

	getAutomationActive(access: AccessEvent): string {
		let retString = '';
		const arrayString = [];
		if (access.ActionEvents !== null && access.ActionEvents.length > 0) {
			for (const event of access.ActionEvents) {
				if (event.DeviceName !== '') {
					switch (event.Command) {
						case 3:
							arrayString.push(event.DeviceName + ' - ' + this.translate.instant('TOTAL_OPEN'));
							break;
						case 4:
							arrayString.push(event.DeviceName + ' - ' + this.translate.instant('PARTIAL_OPEN'));
							break;
						case 5:
							arrayString.push(event.DeviceName + ' - ' + this.translate.instant('CLOSE'));
							break;
						case 129:
							arrayString.push(event.DeviceName + ' - ' + this.translate.instant('STOP'));
							break;
						case 9001:
							arrayString.push(this.translateOutputEvent(event));
							break;
						case 9002:
							arrayString.push(this.translateOutputEvent(event));
							break;
						case 9003:
							arrayString.push(this.translateOutputEvent(event));
							break;
						case 9004:
							arrayString.push(this.translateOutputEvent(event));
							break;
						default:
							arrayString.push(event.DeviceName);
					}
				}
			}
		}

		if (arrayString.length === 0) {
			retString = '{{NOT_PASSAGE}}';
		} else {
			arrayString.sort((a, b) => {
				if (a.toLowerCase() < b.toLowerCase()) //sort string ascending
					return -1
				return 1
			});
			for (const str of arrayString) {
				if (retString === '') {
					retString = str;
				} else {
					retString = retString + ', ' + str;
				}
			}
		}
		return this.translateData(retString);
	}


	translateOutputEvent(event: ActionEvent): string {
		let result;
		const str = event.DeviceName.split('{{OUTPUT}}');
		if (str !== undefined && str.length > 1) {
			result = str[1].trim();
		} else {
			return event.DeviceName;
		}
		if (this.commands != undefined && this.commands.length > 0) {
			if (result.indexOf('1') >= 0) {
				return this.convertStringOutput(event, 1);
			} else if (result.indexOf('2') >= 0) {
				return this.convertStringOutput(event, 2);
			} else if (result.indexOf('3') >= 0) {
				return this.convertStringOutput(event, 3);
			} else if (result.indexOf('4') >= 0) {
				return this.convertStringOutput(event, 4);
			}
		}
		return event.DeviceName;
	}

	convertStringOutput(event: ActionEvent, output: number): string {
		if (this.automationsAlias !== undefined && this.automationsAlias.Outputs) {
			const out = this.automationsAlias.Outputs.find(c => c.Id === output);
			if (out !== undefined) {
				let outDescription = out.Description;
				if (outDescription.includes('{OUTPUT}')) {
					outDescription = this.translate.instant('LOG_OUTPUT') + output.toString();
				}
				return outDescription + this.convertStringOutputType(event);
			} else {
				return event.DeviceName + this.convertStringOutputType(event);
			}
		}
		/*const commIdOutput = 143 + output; //create id, output command
		const comm = this.commands.find(c => c.Id === commIdOutput);
		if (comm !== undefined) {
			return comm.Description;
		} else {
			return event.DeviceName;
		}*/
		return event.DeviceName + this.convertStringOutputType(event);
	}

	convertStringOutputType(event: ActionEvent): string {
		if (event.Source !== undefined && event.Source !== '') {
			switch (event.Source) {
				case this.TYPE_OUTPUT_ON: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_ON");
				}
				case this.TYPE_OUTPUT_OFF: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_OFF");
				}
				case this.TYPE_OUTPUT_ON_TIME: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_ON_TIME");
				}
				case this.TYPE_OUTPUT_ON_MANTAINE: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_ON_MANTAINE");
				}
				case this.TYPE_OUTPUT_ON_STEP: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_ON_STEP");
				}
				case this.TYPE_OUTPUT_OFF_MANTAINE: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_OFF_MANTAINE");
				}
				case this.TYPE_OUTPUT_OFF_STEP: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_OFF_STEP");
				}
				case this.TYPE_OUTPUT_ON_FOR_SERVICE: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_ON_FOR_SERVICE");
				}
				case this.TYPE_OUTPUT_OFF_FOR_SERVICE: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_OFF_FOR_SERVICE");
				}
				case this.TYPE_OUTPUT_JUST_ON: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_JUST_ON");
				}
				case this.TYPE_OUTPUT_JUST_OFF: {
					return ' - ' + this.translate.instant("TYPE_OUTPUT_JUST_OFF");
				}
			}
		}
		return '';
	}

	isRbe24230(): boolean {
		return (this.deviceModel !== undefined && (this.deviceModel.Id === EDeviceModel.RBE24230 || this.deviceModel.Id === EDeviceModel.RBE230 ||
			this.deviceModel.Id === EDeviceModel.RBE24 || this.deviceModel.Id === EDeviceModel.GEN_RBE24230)) && this.tabIndex > 1; // TAB INDEX FOR RBE24 LOG IS 3
	}

	isSelectLogTab(): boolean {
		return this.isRbe24230();
	}

	refresh(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		const endDate = new Date(this.today.getTime());
		this.f.endDateTime.setValue(endDate);
	}

	dispatchGetLogs(): void {
		if (this.isSelectLogTab()) {
			this.logsLoading = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			let output = '';
			let actiondevicename = '';
			let commands = null;
			switch (this.f.function.value.Id) {
				case 144:
					output = '1';
					break;
				case 145:
					output = '2';
					break;
				case 146:
					output = '3';
					break;
				case 147:
					output = '4';
					break;
				case 256:
				case 257:
				case 258:
				case 259:
				case 10005:
					actiondevicename = this.f.function.value.DeviceName;
					break;
				case 260:
				case 261:
				case 262:
				case 263:
				case 10021:
					actiondevicename = this.f.function.value.DeviceName;
					break;
				case 264:
				case 265:
				case 266:
				case 267:
				case 10037:
					actiondevicename = this.f.function.value.DeviceName;
					break;
				case 268:
				case 269:
				case 270:
				case 271:
				case 10053:
					actiondevicename = this.f.function.value.DeviceName;
					break;
				default:
					output = null;
					actiondevicename = null;
			}
			switch (this.f.function.value.Id) {
				case 256:
				case 260:
				case 264:
				case 268:
					commands = [2, 3];
					break;
				case 257:
				case 261:
				case 265:
				case 269:
					commands = [4];
					break;
				case 258:
				case 262:
				case 266:
				case 270:
					commands = [5];
					break;
				case 259:
				case 263:
				case 267:
				case 271:
					commands = [129];
					break;
				case 10005:
				case 10021:
				case 10037:
				case 10053:
					commands = [8];
					break;
				default:
					commands = null;
			}
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.store.dispatch(DeviceActions.getRbeAccessLog({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime, filter: this.f.searchFilter.value, typeAction: this.f.type.value, output: output,
					actiondevicename: actiondevicename, commands: commands,
					result: this.f.result.value,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order, size: this.paging.size, page: this.paging.page
				}));
			}
		}
	}

	onSelectAccessType() {
		this.dispatchGetLogs();
	}

	onChangeSearch() {
		this.dispatchGetLogs();
	}

	onSelectAccessResult() {
		this.dispatchGetLogs();
	}

	onSelectPicker() {
		this.dispatchGetLogs();
	}

	//EXPORT

	exportLimitWarning(): void {
		this.acceptButtonStyle = "p-button-primary";
		this.rejectButtonVisible = false;
		this.confirmationService.confirm({
			header: this.translate.instant('WARNING_EXPORT_LOG_TITLE'),
			message: this.translate.instant('WARNING_EXPORT_LOG_MESSAGE'),
			acceptLabel: this.translate.instant('CONFIRM'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => { },
			reject: () => { }
		});
	}

	exportToCsv() {
		if (this.resultLength > this.MAX_EXPORT_LOG) {
			this.exportLimitWarning();
		} else {
			this.saving = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.logsLoading = true;
				this.store.dispatch(DeviceActions.getRbeAccessLogExport({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime, filter: this.f.searchFilter.value, typeAction: this.f.type.value,
					result: this.f.result.value,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order
				}));
			}
			this.logsExportSub = this.logsExport$.subscribe(
				(logs) => {
					if (logs !== undefined && logs.length > 0) {
						const data = this.prepareDataForLogs(logs);
						const map = new Map();
						map.set("EventDate", this.translate.instant('EVENT_DATE'));
						map.set("User", this.translate.instant('USER'));
						map.set("Passage", this.translate.instant('COMMAND_DEVICE'));
						map.set("Result", this.translate.instant('LOG_RESULT'));
						map.set("Automation", this.translate.instant('OUTPUT_AUTOMATIONS'));
						exportToCsv(data, 'exportData', map);
						this.logsExportSub?.unsubscribe();
						this.logsLoading = false;
						this.store.dispatch(DeviceActions.resetRbeAccessLogExport());
						this.saving = false;
					}
				}
			)
		}
	}

	prepareDataForLogs(logs: AccessEvent[]): AccessExportLog[] {
		const list = [];
		for (const log of logs) {
			list.push(this.prepareDataForLog(log));
		}
		return list;
	}

	prepareDataForLog(log: AccessEvent): AccessExportLog {
		const logExport = new AccessExportLog();
		logExport.EventDate = moment.utc(log.EventDate).format('DD-MM-yyyy HH:mm:ss');
		logExport.User = this.userData(log);
		logExport.Passage = this.passageData(log);
		logExport.Result = this.getResult(log.Result);
		logExport.Automation = this.getAutomationActive(log);
		return logExport;
	}


	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	overTablet(): boolean {
		return StandardPageLayout.overTablet(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	col3ResponsiveStd(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	col2Responsive(): string {
		return (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_MX7_LATER) ? "col-2 px-4" : (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_COL6) ? 'col-3' : 'col-6';
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}
}
